import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const ZONES = [
  { id: 'report_header', tone: 'violet', title: 'Report Header', desc: 'Appears once at the very top of the report. Good for report title, date range, summary KPIs.' },
  { id: 'header',        tone: 'sky',    title: 'Page Header',   desc: 'Repeats on every page. Good for logos, column headers, page titles.' },
  { id: 'body',          tone: 'emerald', title: 'Body',          desc: 'Main content area. Charts, tables, KPIs. Tables can span pages.' },
  { id: 'footer',        tone: 'sky',    title: 'Page Footer',   desc: 'Repeats on every page. Good for page numbers, dates, disclaimers.' },
  { id: 'report_footer', tone: 'violet', title: 'Report Footer', desc: 'Appears once at the very end of the report. Good for grand totals, signatures, notes.' },
];

const TONE_CLASS = {
  violet:  'border-violet-500/20 hover:border-violet-500/40 hover:bg-violet-500/5',
  sky:     'border-sky-500/20 hover:border-sky-500/40 hover:bg-sky-500/5',
  emerald: 'border-emerald-500/20 hover:border-emerald-500/40 hover:bg-emerald-500/5',
};

/**
 * Asks the user where in the multi-page report a newly-added visual should be placed.
 * Closing the dialog (X / Esc / outside-click) defaults to 'body' to avoid losing the visual.
 */
export function VisualPlacementDialog({ open, onConfirm }) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onConfirm('body'); }}>
      <DialogContent className="glass-card border-border/50 rounded-2xl sm:max-w-xs" data-testid="viz-placement-dialog">
        <DialogHeader><DialogTitle className="font-heading">Where should this visual go?</DialogTitle></DialogHeader>
        <div className="space-y-1.5 mt-2">
          {ZONES.map(z => (
            <button
              key={z.id}
              onClick={() => onConfirm(z.id)}
              className={`w-full text-left p-3 rounded-xl border transition-all ${TONE_CLASS[z.tone]}`}
              data-testid={`place-${z.id}`}
            >
              <p className="text-xs font-semibold text-foreground">{z.title}</p>
              <p className="text-[9px] text-muted-foreground mt-0.5">{z.desc}</p>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
